import { Item as AccordionItem } from "@radix-ui/react-accordion";
import { type ComponentProps } from "react";

import { cn } from "../../utils";

export const Item = ({ ref, className, ...props }: ComponentProps<typeof AccordionItem>) => (
  <AccordionItem ref={ref} className={cn(className)} {...props} />
);
Item.displayName = "AccordionItem";

export default Item;
